import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor{

constructor() { }

intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const authToken = JSON.parse(localStorage.getItem('currentUserData') || '{}');
  if (request.headers.get('IgnoreInterceptor') !== null) {
    const newHeaders = request.headers.delete('IgnoreInterceptor');
    const newRequest = request.clone({ headers: newHeaders });
    return next.handle(newRequest);
  } else if(authToken.accessToken) {
    const authReq = request.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken.accessToken}`
      }
    });
    return next.handle(authReq);
  }
  return next.handle(request);
}


}
